import { createTheme } from "@mui/material/styles";

// styles passed when customizing MUI components
export const styles = {
  "accent-color": "#8d742d",
  "background-primary": "#1f2f4d",
  "background-primary-transparent-80": "#1f2f4dcc",
  "background-secondary": "#2a4a6d",
  "background-secondary-hover": "#2a4a6d99",
  "background-tertiary": "#3f6fa4",
  "background-quaternary": "#6a95c6",
  "text-primary": "#EEE",
  "text-secondary": "#000",
  "text-tertiary": "#444",
  "text-quaternary": "#bbb",
  "font-family": "'Source sans', sans-serif",
};

export const iconButtonStyle = {
  mt: "5px",
  mb: "5px",
  p: 0,
  width: "40px",
  height: "40px",
  zIndex: 3,
  borderRadius: 0,
  backgroundColor: styles["background-primary"],
};

const transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195,
  },
};

export const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      dark: "#999",
      main: "#eee",
      light: "#fff",
      contrastText: "#000",
    },
    secondary: {
      main: "#3f6fa4",
    },
    accent: {
      main: "#8d742d",
    },
    background: {
      main: "#1f2f4d",
    },
  },
  typography: {
    fontFamily: "Mulish, sans-serif",
  },
  transitions,
});

export const boxShadowStyle = "0 1px 4px rgb(0 0 0 / 30%)";

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "90%",
  maxHeight: "75%",
  overflowY: "auto",
  bgcolor: styles["background-primary"],
  border: "2px solid #000",
  boxShadow: 24,
  p: 1,
};
